import React from 'react';
import Component from '../../components/Component';
import DomainsData from '../DomainsData';

class UserDomains extends Component {
    constructor(props) {
        super();

        this.onOpenModal = this.onOpenModal.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);
        try {
            if (props.domains) {
                const decoded = props.domains.replace(/&quot;/g, '"');
                this.domains = decoded ? JSON.parse(String(decoded)) : [];
            }
        } catch (err) {
            this.domains = [];
        }

        this.state = {
            isOpen: false,
        };
    }

    onOpenModal() {
        this.setState({ isOpen: true });
    }

    onCloseModal() {
        this.setState({ isOpen: false });
    }

    render() {
        return this.domains?.length === 0 ? (
            'There is no domain'
        ) : (
            <>
                <div className="domain-information">
                    <div className="domain-main-info">
                        <button className="btn-icon" onClick={this.onOpenModal}>
                            <i className="text-success icon-external-link"></i>
                        </button>
                    </div>
                    <div>
                        {this.domains.map((domain) => (
                            <div className="domain-information-content" key={domain.id}>
                                <div className="domain-name">
                                    <div>
                                        <small>
                                            {domain.active ? (
                                                <i className="text-success icofont-verification-check"></i>
                                            ) : (
                                                <i className="text-danger icofont-ui-close"></i>
                                            )}
                                        </small>
                                        <a href={`/domains/${domain.id}`}>{domain.url}</a>
                                    </div>
                                </div>
                            </div>
                        ))}
                        <DomainsData
                            isOpen={this.state.isOpen}
                            onClose={this.onCloseModal}
                            domains={this.domains}
                        />
                    </div>
                </div>
            </>
        );
    }
}

export default UserDomains;
